export const HouseholdInsuranceRoutes = {
    ROOT: "/household-insurance",
    PERSONAL_DATA: "/household-insurance/personal-data",
    SUCCESS: "/household-insurance/success",
    NEW_PHONE: "/household-insurance/new-phone",
    NEW_ADDRESS: "/household-insurance/new-address",
    NEW_EMAIL: "/household-insurance/new-email",
};



// WEBPACK FOOTER //
// ./src/components/householdInsurance/HouseholdInsuranceRoutes.ts